import DashContainer from 'modules/dashboard/_common/DashContainer'
import CheckinHome from 'modules/dashboard/checkin/producer/CheckinHome'
import React from 'react'

export default function DashCheckin() {
  return (
    <DashContainer title={'Checkin'}>
        <CheckinHome />
    </DashContainer>
  )
}
